import axios from "axios";

export const patientConfirmRequest = async (params: {
    email: string;
    fname: string;
    lname: string;
    dob: string;
    phone: string;
    patient_uid: string;
    patient_id: string;
    account_type: string;
    ciam_token: string;
}): Promise<void> => {
  const { email, fname, lname, dob, phone, patient_uid, patient_id, account_type, ciam_token } = params;
  const { data } = await axios.post("/api/v2/ciam_dependent_associations", {
    email,
    fname,
    lname,
    dob,
    phone,
    patient_uid,
    patient_id,
    account_type,
    ciam_token,
  },{
    headers: {
        'Content-Type': 'application/json'
    }
});

  return data;
};
